"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Epsilon Nav Menu Class
 */
var EpsilonNavMenus = /** @class */ (function () {
    /**
     * Constructor
     * @param api
     */
    function EpsilonNavMenus(api) {
        this.api = api;
        this.context = jQuery('#epsilon-section-navigation-menu');
        this.handleEvents();
    }
    EpsilonNavMenus.prototype.handleEvents = function () {
        var _this = this;
        jQuery('#submit-epsilon-section').on('click', function (evt) {
            var self = _this;
            var object = {
                label: _this.context.find('#epsilon-section-label').val(),
                value: _this.context.find('#epsilon-section-id').val()
            };
            evt.preventDefault();
            _this.context.find('.spinner').addClass('is-active');
            _this.api.addItemToMenu({
                '-1': {
                    'menu-item-type': 'custom',
                    'menu-item-extra': 'epsilon-frontpage-section',
                    'menu-item-url': '#' + object.value,
                    'menu-item-section': object.value,
                    'menu-item-title': object.label
                }
            }, self.api.addMenuItemToBottom, self.menuAdded);
        });
    };
    EpsilonNavMenus.prototype.menuAdded = function () {
        var div = jQuery('#epsilon-section-navigation-menu');
        div.find('.spinner').removeClass('is-active');
        div.find('#epsilon-section-navigation-menu #epsilon-section-id').val(0).blur();
        div.find('#epsilon-section-navigation-menu #epsilon-section-label').val('').blur();
    };
    return EpsilonNavMenus;
}());
exports.EpsilonNavMenus = EpsilonNavMenus;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/admin/nav-menus/nav-menus.ts
// module id = 10
// module chunks = 2